<div class="dialog-wrap">
  <p class="supervisor-disabled-text" *ngIf="data.supervisorDisabledLicense">{{"LICENSE_MODAL.SUPERVISOR_DISABLED_LICENSE" | translate}}</p>
  <ng-container *ngIf="!data.supervisorDisabledLicense">
    <p class="main-text">{{ 'LICENSE_MODAL.MAIN_TEXT' | translate}}</p>
    <div class="enter-core-wrap">
      <mat-form-field>
        <mat-label>{{ "LICENSE_MODAL.LICENCE_CODE_TEXT" | translate }}</mat-label>
        <input matInput [(ngModel)]="licenseCode">
      </mat-form-field>
    </div>
  </ng-container>
  <div class="dialog-actions">
    <button mat-raised-button color="primary" [disabled]="data.supervisorDisabledLicense" (click)="submit()">{{ "LICENSE_MODAL.SUBMIT" | translate }}</button>
  </div>
</div>
